/**
 * Event Configuration Constants
 * 
 * Defines the official start time for Iron Makers Day @ one:demo forge
 */

/**
 * Event start time: 2026-02-17 8:30 CET/CEST
 * 
 * Note: Germany observes Central European Time (CET, UTC+1) in winter
 * and Central European Summer Time (CEST, UTC+2) in summer.
 * February 17, 2026 falls in winter, so CET (UTC+1) applies.
 */
export const EVENT_START_TIME = new Date('2026-02-17T08:30:00+01:00');
